import React, { useContext, useState, useEffect } from "react";
import { CartContext } from "../context/CartContext";

const ItemList = (props) => {
  const cartItem = useContext(CartContext);

  const [item, setItem] = useState({ product: "", type: "" });

  useEffect(() => {
    const findInCart = cartItem.items.find((val) => {
      return val.product.pk === props.pk;
    });
    setItem(findInCart);
  }, [cartItem.items, props.pk]);

  const delItem = (pk) => {
    const array = [...cartItem.items];
    const index = array.findIndex((item) => {
      return item.product.pk === pk;
    });
    array.splice(index, 1);
    cartItem.setItems(array);
  };

  if (item !== undefined) {
    if (item.type === "vazni") {
      return (
        <div>
          <div className="alert alert-success mt-2" role="alert">
            وزن : {item.value.split("#")[0]} گرم
          </div>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => {
              delItem(item.product.pk);
            }}
          >
            حذف
          </button>
        </div>
      );
    } else if (item.type === "tedadi") {
      return (
        <div>
          <table className="table table-borderless mt-2 table-sm rtl">
            <thead>
              <tr className="table-primary">
                <th scope="col">#</th>
                <th scope="col">تعداد</th>
                <th scope="col">سایز</th>
              </tr>
            </thead>
            <tbody>
              {item.value
                .split("#")[0]
                .split("@")
                .map((val, index) => (
                  <tr key={index} className="table-primary">
                    <th scope="row">{index + 1}</th>
                    <td>{val.split("~")[0]}</td>
                    <td>{val.split("~")[1]}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => {
              delItem(item.product.pk);
            }}
          >
            حذف
          </button>
        </div>
      );
    } else {
      return <div></div>;
    }
  } else {
    return <div></div>;
  }
};

export default ItemList;
